import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import { Input, Select, Row, Col, Button } from "antd";

const { Option } = Select;

export function CostumeFilter({ filter, onFilterChange }) {
  const handleSearchChange = (value) => {
    onFilterChange?.({ ...filter, page: 1, search: value });
  };

  const handleTypeChange = (value) => {
    onFilterChange?.({ ...filter, page: 1, type: value });
  };

  const handleStatusChange = (value) => {
    onFilterChange?.({ ...filter, page: 1, status: value });
  };

  const handleReset = () => {
    onFilterChange?.({
      page: 1,
      limit: 10,
      search: "",
      type: "",
      status: "",
      event: filter.event,
    });
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col xs={24} md={6}>
          <Input
            placeholder="Tìm kiếm theo tên hoặc email"
            prefix={<SearchOutlined />}
            onChange={(e) => handleSearchChange(e.target.value)}
            value={filter.search || ""}
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={24} md={6}>
          <Select
            placeholder="Lọc theo loại"
            onChange={handleTypeChange}
            allowClear
            value={filter.type || undefined}
            style={{ width: "100%" }}
          >
            <Option value="borrow">Mượn</Option>
            <Option value="buy">Mua</Option>
          </Select>
        </Col>
        <Col xs={24} md={6}>
          <Select
            placeholder="Lọc theo trạng thái"
            onChange={handleStatusChange}
            allowClear
            value={filter.status || undefined}
            style={{ width: "100%" }}
            disabled={!filter.type}
          >
            <Option value="pending" disabled={filter.type !== "borrow"}>
              Chờ nhận
            </Option>
            <Option value="borrowed" disabled={filter.type !== "borrow"}>
              Đã mượn
            </Option>
            <Option value="returned" disabled={filter.type !== "borrow"}>
              Đã trả
            </Option>
            <Option value="cancelled" disabled={filter.type !== "borrow"}>
              Đã hủy
            </Option>
            <Option value="lost">Mất</Option>
            <Option value="paid" disabled={filter.type !== "buy"}>
              Đã thanh toán
            </Option>
            <Option value="unpaid" disabled={filter.type !== "buy"}>
              Chưa thanh toán
            </Option>
          </Select>
        </Col>

        <Col xs={24} md={6}>
          <Button
            icon={<ReloadOutlined />}
            onClick={handleReset}
            type="default"
          >
            Đặt lại bộ lọc
          </Button>
        </Col>
      </Row>
    </div>
  );
}
